import { defineMessages } from 'react-intl';

const messages = defineMessages({
  stepTitle: {
    id: 'registration.confirmation.stepTitle',
    defaultMessage: 'Confirmation',
    description: 'Registration confirmation step title',
  },
  title: {
    id: 'registration.confirmation.title',
    defaultMessage: 'Confirmation',
    description: 'Registration confirmation title',
  },
  description: {
    id: 'registration.confirmation.description',
    defaultMessage: 'Please confirm your information to continue creating your AGCO account.',
    description: 'Registration confirmation description',
  },
  agcoID: {
    id: 'registration.confirmation.agcoID',
    defaultMessage: 'AGCO ID',
    description: 'Registration confirmation AGCO ID title',
  },
  editName: {
    id: 'registration.confirmation.editName',
    defaultMessage: 'Edit name',
    description: 'Registration confirmation edit name',
  },
  editAddress: {
    id: 'registration.confirmation.editAddress',
    defaultMessage: 'Edit address',
    description: 'Registration confirmation edit address',
  },
  editPhone: {
    id: 'registration.confirmation.editPhone',
    defaultMessage: 'Edit phone number',
    description: 'Registration confirmation edit phone number',
  },
  editBusinessInformation: {
    id: 'registration.confirmation.editBusinessInformation',
    defaultMessage: 'Edit business information',
    description: 'Registration confirmation edit business information',
  },
  mobileNo: {
    id: 'registration.confirmation.mobileNo',
    defaultMessage: 'Mob. no.',
    description: 'Registration confirmation mobile number',
  },
  officeNo: {
    id: 'registration.confirmation.officeNo',
    defaultMessage: 'Office no.',
    description: 'Registration confirmation office number',
  },
});

export default messages;
